import { ComponentCommonDownloadableContentList } from '@/graphql/generated/graphql';
import icon from '@/assets/downloadable-content.png';
import classNames from 'classnames';

function DownloadableContent({
  component,
  className,
  isDefaultContentTemplate = false,
  title,
}: {
  component?: ComponentCommonDownloadableContentList;
  className?: string;
  title?: string;
  isDefaultContentTemplate?: boolean;
}) {
  if (component?.list?.length === 0) {
    return null;
  }

  return (
    <>
      <h1
        className={classNames('text-sh-md font-bold', className, {
          'my-0': isDefaultContentTemplate,
          'my-sh-30': !isDefaultContentTemplate,
        })}>
        {title || 'Downloadable content'}
      </h1>
      <ul key={`downloadable`} className="!m-0 !p-0">
        {component?.list?.map((c) => (
          <li key={c?.id} className="flex flex-col !pb-4 pl-0 text-sh-sm last:!pb-0">
            <a
              href={c!.content!.data!.attributes!.url!}
              rel="noreferrer"
              target="_blank"
              className="flex items-center font-bold">
              <img src={icon} className="mr-1" alt="downloadable icon" />
              {c?.title}
            </a>
            <ol className="!pl-6 text-sh-xxs">{c?.description}</ol>
          </li>
        ))}
      </ul>
    </>
  );
}

export default DownloadableContent;
